import { useTranslations } from 'next-intl';
import React from 'react';
import { formatPrice } from '../utils/format-price';

type SavingsProps = {
  savings: number;
  isMonthlyRate: boolean;
};

export default function SavingsInfo({ savings, isMonthlyRate }: SavingsProps) {
  const t = useTranslations('priceComparison');
  const savingsValue = isMonthlyRate ? savings / 12 : savings;
  const formattedValue = formatPrice(savingsValue, false);

  return (
    <div
      data-testid="savings-info"
      className="bg-[var(--color-informative-graph-primary)] text-center min-h-[56px] md:min-h-10 md:min-w-[159px] content-center font-semibold text-[var(--color-text-inverse)] md:py-2 md:px-4 md:rounded-[4px] md:mb-11"
    >
      {t('savingsInfo', { value: formattedValue })}
    </div>
  );
}
